import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Pill from 'LuxKit/Pill'
import SolidPlaneIcon from 'LuxKit/Icons/solid/SolidPlaneIcon'
import flightBundleGlossaryMessages from 'i18n/flightBundleGlossaryMessages'

const BundlePill = styled(Pill)`
  align-self: flex-start;
`

/**
 * "Hotel & Flight bundle" label for charter-bundle hotels (e.g. Maldives
 * MEL↔MLE direct charter) across trip-planner surfaces. Shown whenever a saved
 * accommodation item carries a charterFlightBundle selection.
 */
function CharterBundleLabel() {
  const intl = useIntl()

  return (
    <BundlePill startIcon={<SolidPlaneIcon />}>
      {intl.formatMessage(flightBundleGlossaryMessages.hotelAndFlightBundle)}
    </BundlePill>
  )
}

export default CharterBundleLabel
